export const FETCH_CUSTOMER_REQUEST =
  'integrations/shopify/FETCH_CUSTOMER_REQUEST'
export const FETCH_CUSTOMER_REQUEST_SUCCESS =
  'integrations/shopify/FETCH_CUSTOMER_REQUEST_SUCCESS'
export const FETCH_CUSTOMER_REQUEST_FAILURE =
  'integrations/shopify/FETCH_CUSTOMER_REQUEST_FAILURE'

export const FETCH_ORDERS_REQUEST = 'integrations/shopify/FETCH_ORDERS_REQUEST'
export const FETCH_ORDERS_REQUEST_SUCCESS =
  'integrations/shopify/FETCH_ORDERS_REQUEST_SUCCESS'
export const FETCH_ORDERS_REQUEST_FAILURE =
  'integrations/shopify/FETCH_ORDERS_REQUEST_SUCCESS'

export const FETCH_CUSTOMER_EVENTS_REQUEST =
  'integrations/shopify/FETCH_CUSTOMER_EVENTS_REQUEST'
export const FETCH_CUSTOMER_EVENTS_REQUEST_SUCCESS =
  'integrations/shopify/FETCH_CUSTOMER_EVENTS_REQUEST_SUCCESS'
export const FETCH_CUSTOMER_EVENTS_REQUEST_FAILURE =
  'integrations/shopify/FETCH_CUSTOMER_EVENTS_REQUEST_FAILURE'
